import "./ClientDetailsComponent.scss";
import template from "./ClientDetailsComponent.html";
import {IComponentOptions} from "angular";
import {Observable, ReplaySubject} from "rxjs";
import {AccountManagementService} from "../../services/AccountManagmentService";
import {Individual, ShareAccount} from "../../types/AccountManagementRecords";
import {isNotNull} from "../../../js/util/UtilFunctions";
import {EquityAccountRecord} from "../../equity/types/EquityAccountRecord";

export const ClientDetails = "tfClientDetails";

export function clientDetails(): IComponentOptions {
    return {
        template,
        bindings: {
            account: "<"
        },
        controllerAs: "ctrl",
        controller: ClientDetailsComponentController
    };
}

export class ClientDetailsComponentController {

    private readonly tradingAccountDetails$: Observable<ShareAccount>;
    private readonly individuals$: Observable<Individual[]>;

    /** @input */
    public set account(account: EquityAccountRecord | null) {
        if (account != null) {
            this.account$.next(account);
        }
    }

    private readonly account$ = new ReplaySubject<EquityAccountRecord>(1);


    /** @ngInject */
    public constructor(private readonly accountManagementService: AccountManagementService) {
        this.tradingAccountDetails$ = this.account$
                                          .map((account) => account.accountNumber)
                                          .switchMap((account) => this.retrieveShareAccountDetails(account))
                                          .map((details) => details)
                                          .filter(isNotNull)
                                          .publishReplay(1)
                                          .refCount();
        this.individuals$ = this.tradingAccountDetails$
            .map(details => details.individuals);
    }

    private retrieveShareAccountDetails(accountNumber: string): Observable<ShareAccount> {
        return Observable.of(accountNumber)
                         .flatMap((i) => this.accountManagementService.detail(accountNumber))
                         .catch((err) => Observable.empty());
    }
}
